import PlansFrequency from "./PlansFrequency";
import parseJsonSafe from "../utils/parseJsonSafe";
import SubscriptionPlanCard from "./SubscriptionPlanCard";
import SubscriptionPlansCarousel from "./SubscriptionPlansCarousel";
import React, { memo } from "react";
import useWindowWidth from "../hooks/useWindowWidth";
import usePlans from "../hooks/usePlans";
import ChangePlanModal from "./ChangePlanModal";
import DowngradePlanModal from "./DowngradePlanModal";
import CancelPlanModal from "./CancelPlanModal";
import PlanCancelAlert from "./PlanCancelAlert";
import RenewPlanModal from "./RenewPlanModal";

const PlansGrid = ({ successUrl, onCompleted }) => {
  const width = useWindowWidth();

  const {
    frequency,
    setFrequency,
    plans,
    loading,
    selectedPlan,
    setSelectedPlan,
    showChangePlanModal,
    setShowChangePlanModal,
    onChangePlanSubmit,
    onChangePlanIntent,
    setShowDowngradePlanModal,
    showDowngradePlanModal,
    setShowCancelPlanModal,
    showCancelPlanModal,
    showRenewPlanModal,
    setShowRenewPlanModal,
  } = usePlans({
    successUrl,
    onCompleted,
  });

  const submit = e => {
    e.preventDefault();
    return onChangePlanSubmit();
  };

  return (
    <>
      <div className="flex flex-col gap-6 items-center">
        <div className="flex justify-center">
          <PlansFrequency frequency={frequency} setFrequency={setFrequency} />
        </div>

        <PlanCancelAlert />

        {width > 640 ? (
          <div className="flex gap-6 mt-12">
            {plans.map((i, idx) => {
              const {
                originalPrice,
                features = [],
                otherFeatures = [],
                mostPopular = false,
              } = parseJsonSafe(i.benefits);

              return (
                <SubscriptionPlanCard
                  key={idx}
                  i={i}
                  features={features}
                  otherFeatures={otherFeatures}
                  mostPopular={mostPopular}
                  onSubmit={onChangePlanIntent}
                  originalPrice={originalPrice}
                  selectedPlan={selectedPlan}
                  setSelectedPlan={setSelectedPlan}
                  loading={loading}
                />
              );
            })}
          </div>
        ) : (
          <SubscriptionPlansCarousel
            plans={plans}
            onSubmit={onChangePlanIntent}
            selectedPlan={selectedPlan}
            setSelectedPlan={setSelectedPlan}
            loading={loading}
          />
        )}
      </div>

      <ChangePlanModal
        selectedPlan={selectedPlan}
        loading={loading === selectedPlan?.id}
        open={showChangePlanModal}
        onClose={() => setShowChangePlanModal(false)}
        onSubmit={submit}
      />

      <DowngradePlanModal
        selectedPlan={selectedPlan}
        loading={loading === selectedPlan?.id}
        open={showDowngradePlanModal}
        onClose={() => setShowDowngradePlanModal(false)}
        onSubmit={submit}
      />

      <CancelPlanModal
        loading={loading === selectedPlan?.id}
        open={showCancelPlanModal}
        onClose={() => setShowCancelPlanModal(false)}
        onSubmit={submit}
      />

      <RenewPlanModal
        selectedPlan={selectedPlan}
        loading={loading === selectedPlan?.id}
        open={showRenewPlanModal}
        onClose={() => setShowRenewPlanModal(false)}
        onSubmit={submit}
      />
    </>
  );
};

export default memo(PlansGrid);
